
import { computed, defineComponent } from "vue";
import BaseLayout from "~/components/base/BaseModuleLayout.vue";
import Account from "@/components/account/Account.vue";
import AccountForm from "@/components/account/login/AccountForm.vue";
import AccountBookingAmendment from "@/components/account/booking/AccountMyBookingAmendment.vue";
import AccountBookingCancel from "@/components/account/booking/AccountMyBookingCancel.vue";
import AccountConfirmationEmail from "@/components/account/booking/AccountMyBookingConfirmEmail.vue";
import BaseBookingLayout from "@/components/base/BaseBookingLayout.vue";
import BaseSpinner from "@/components/base/BaseSpinner.vue";
import { useUserStore } from "@/store/user";

export default defineComponent({
	components: {
		BaseLayout,
		BaseBookingLayout,
		Account,
		BaseSpinner,
		AccountForm,
		AccountBookingAmendment,
		AccountBookingCancel,
		AccountConfirmationEmail
	},
	props: {
		isAgent: Boolean
	},
	setup() {
		const userStore = useUserStore();
		const isLoggedIn = computed(() => userStore.getIsLoggedIn);

		return { isLoggedIn };
	},
});
